/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_PausedInputs */

const zh_status_paused = /** @type {(inputs: Status_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已暂停`)
};

const en_status_paused = /** @type {(inputs: Status_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paused`)
};

const es_status_paused = /** @type {(inputs: Status_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pausado`)
};

/**
* | output |
* | --- |
* | "Paused" |
*
* @param {Status_PausedInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const status_paused = /** @type {((inputs?: Status_PausedInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_PausedInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_status_paused(inputs)
	if (locale === "en") return en_status_paused(inputs)
	return es_status_paused(inputs)
});